/** Максимальная ширина картинки карточки карусели, CSS px: 216 на телефоне, до 260 на планшете (3.3 карточки). */
export const CAROUSEL_CARD_IMAGE_SLOT_WIDTH = 260;
